module.exports = __webpack_public_path__ + "static/media/banner-4-novo2-2024.5e2872f7.jpg";